import { render, staticRenderFns } from "./PerformanceQueryTrend.vue?vue&type=template&id=cd4c9dfc&scoped=true"
import script from "./PerformanceQueryTrend.vue?vue&type=script&lang=js"
export * from "./PerformanceQueryTrend.vue?vue&type=script&lang=js"
import style0 from "./PerformanceQueryTrend.vue?vue&type=style&index=0&id=cd4c9dfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c9dfc",
  null
  
)

export default component.exports